import { ConfigProvider, Table as AntdTable, TableProps } from 'antd';
import { ThemeConfig } from 'antd/es/config-provider/context';
import { useSearchParams } from 'react-router-dom';
import { useSetSearchParamsValue } from '../../hooks/use-set-search-params-value';

interface Props {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  tableProps: TableProps<any>;
  tableConfigProps?: ThemeConfig['token'];
}

const Table = ({ tableProps, tableConfigProps }: Props): JSX.Element => {
  const { pagination, ...otherTableProps } = tableProps;
  const [searchParams] = useSearchParams();
  const setSearchParamsValue = useSetSearchParamsValue();

  const paginationSettings = () => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let paginationProperties: TableProps<any>['pagination'] = false;

    if (pagination) {
      paginationProperties = {
        showSizeChanger: false,
        current: Number(searchParams.get('page')) || 1,
        defaultPageSize: 30,
        onChange: (page: number) => setSearchParamsValue('page', page),
        onShowSizeChange: (current, size) => setSearchParamsValue('limit', size),
        ...pagination,
      };
    }
    return paginationProperties;
  };

  return (
    <ConfigProvider
      theme={{
        token: {
          ...tableConfigProps,
        },
      }}
    >
      <AntdTable
        scroll={{
          x: 'max-content',
        }}
        pagination={paginationSettings()}
        {...otherTableProps}
      />
    </ConfigProvider>
  );
};

export default Table;
